import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";

export function SortableItem({ children, id }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        transform: CSS.Transform.toString(transform),
        transition,
        width: "100%",
        zIndex: isDragging ? 2 : "initial",
        position: "relative",
        border: isDragging ? "solid 1px #868686" : "solid 1px #fff",
        borderRightWidth: isDragging ? "1px" : "0",
        borderLeftWidth: isDragging ? "1px" : "0",
        touchAction: "none",
      }}
      {...attributes}
      {...listeners}
    >
      {children}
    </Box>
  );
}
